var a=function(E){return E.MALE="male",E.FEMALE="female",E.TRANSGENDER="transgender",E}({});export{a as Gender};